<template>
    <div class="breadcrumbs">
        <div v-for="(item, i) in breadcrumbs" :key="`slice-item-${i}`" class="breadscrumb">
            <ServerSideNavigationPrismicLink v-if="isLink(item.breadscrumbText, item.breadscrumbLink)" :field="item.breadscrumbLink" class="link">
                {{ item.breadscrumbText }}
            </ServerSideNavigationPrismicLink>
            <template v-else>{{ item.breadscrumbText }}</template>
            <span v-if="i !== breadcrumbs.length - 1">/</span>
        </div>
    </div>
</template>

<script setup lang="ts">
    import type {HeroSliceSliceDefaultItem} from '@prismicio-types';
    import {usePrismicFieldHelpers} from '#imports';
    import ServerSideNavigationPrismicLink from '~/components/ServerSideNavigationPrismicLink.vue';

    const {isLink} = usePrismicFieldHelpers();

    defineProps<{
        breadcrumbs: HeroSliceSliceDefaultItem[];
    }>();
</script>

<style scoped lang="scss">
    .breadcrumbs {
        display: flex;
        gap: 4px;
        margin-bottom: 32px;
    }

    .breadscrumb {
        display: flex;
        gap: 4px;
        color: var(--joy-color-neutral-50);
    }

    .link {
        color: var(--joy-color-neutral-50);
        display: flex;

        &:last-child {
            color: var(--joy-color-neutral-60);
        }
    }
</style>
